// taken from https://www.gesetze-im-internet.de/gnotkg/anlage_2.html
const notaryFees = [
  { value: 500, fee: 15 },
  { value: 1000, fee: 19 },
  { value: 1500, fee: 23 },
  { value: 2000, fee: 27 },
  { value: 3000, fee: 33 },
  { value: 4000, fee: 39 },
  { value: 5000, fee: 45 },
  { value: 6000, fee: 51 },
  { value: 7000, fee: 57 },
  { value: 8000, fee: 63 },
  { value: 9000, fee: 69 },
  { value: 10000, fee: 75 },
  { value: 13000, fee: 83 },
  { value: 16000, fee: 91 },
  { value: 19000, fee: 99 },
  { value: 22000, fee: 107 },
  { value: 25000, fee: 115 },
  { value: 30000, fee: 125 },
  { value: 35000, fee: 135 },
  { value: 40000, fee: 145 },
  { value: 45000, fee: 155 },
  { value: 50000, fee: 165 },
  { value: 65000, fee: 192 },
  { value: 80000, fee: 219 },
  { value: 95000, fee: 246 },
  { value: 110000, fee: 273 },
  { value: 125000, fee: 300 },
  { value: 140000, fee: 327 },
  { value: 155000, fee: 354 },
  { value: 170000, fee: 381 },
  { value: 185000, fee: 408 },
  { value: 200000, fee: 435 },
  { value: 230000, fee: 485 },
  { value: 260000, fee: 535 },
  { value: 290000, fee: 585 },
  { value: 320000, fee: 635 },
  { value: 350000, fee: 685 },
  { value: 380000, fee: 735 },
  { value: 410000, fee: 785 },
  { value: 440000, fee: 835 },
  { value: 470000, fee: 885 },
  { value: 500000, fee: 935 },
];

export const calculateNotaryFee = (value: number) => {
  const fee = notaryFees.find((fee) => fee.value >= value);
  if (!fee) {
    const lastFee = notaryFees.find((fee) => fee.value === 500_000)!;

    const overshoot = Math.floor((value - lastFee.value) / 50_000);
    const fee = lastFee.fee + overshoot * 80;

    return Math.round(fee);
  }
  return fee.fee;
};
